import {isSet} from '../../Utils/CommonFunctions'; 


export const setAndGetAttributes  = (props)=>{
    const {isMandatory,required} = props;
    //className,attributes,
    let attributesObj = {};
    ['className','class','id','name','disabled','readOnly','maxLength','decimal','placeholder','style','getDateFormat','putDateFormat','onClick','onBlur','onKeyDown'].map((item)=>{
        let attrValue = checkAttributes(props,item);
        if(item==='class'){item='className';}
        if(attrValue!=='UN-DEFINED'){
            if((isMandatory===true && item==='className') || (required===true && item==='className')){
                attrValue=attrValue+' mandatory';
            }
            attributesObj = {
                ...attributesObj,
                [item]:attrValue
            }
        } 
    });
    return attributesObj;
}

export const checkAttributes = (propsObj,attr)=>{
    const attributes = isSet(propsObj.attributes,{});
    if(isSet(attributes[attr],null)!==null){
        return attributes[attr];
    }else if(isSet(propsObj[attr],null)!==null){
        return propsObj[attr];
    }else{
        return 'UN-DEFINED';
    }
}
export const SwitchAttributes = (attr,value)=>{

    switch (attr) {
        case "id":
          return {id:value};
        default:
            return null
    }
}